"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function NewsListConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="127173" className="flex flex-col">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i}>
            <div className="flex flex-row items-center gap-4 py-6 sm:gap-6">
              <div className="h-20 w-20 shrink-0 animate-pulse rounded-sm bg-muted sm:h-24 sm:w-24" />
              <div className="flex flex-1 flex-col justify-center gap-2">
                <div className="h-5 w-3/4 animate-pulse rounded bg-muted" />
                <div className="mt-2 h-4 w-1/4 animate-pulse rounded bg-muted" />
              </div>
            </div>
            {i < 3 && <Separator className="bg-border" />}
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-8 text-center text-sm text-muted-foreground font-sans">
        無法載入推薦文章
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-8 text-center text-sm text-muted-foreground font-sans">
        暫無相關推薦內容
      </div>;
  }
  return <div className="flex flex-col">
      {posts.map((post, i) => {
      const displayDate = post.date ? new Date(post.date).toLocaleDateString() : null;
      return <div key={post.id} data-index={i}>
            <Link to={post.link || "#"} className="group flex flex-row items-center gap-4 py-6 transition-all hover:bg-card hover:shadow-md border border-border rounded-sm sm:gap-6">
              {}
              <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-sm bg-muted sm:h-24 sm:w-24">
                <div className="absolute inset-0 z-10 bg-primary/5 mix-blend-multiply transition-colors duration-300 group-hover:bg-transparent" />
                <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618354/img/generic_news_thumb.png"} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>

              {}
              <div className="flex flex-1 flex-col justify-center">
                <h3 className="font-default text-[18px] font-bold text-primary transition-colors group-hover:opacity-80 line-clamp-2">
                  {post.title}
                </h3>
                
                {displayDate && <div className="mt-2 flex items-center gap-1.5 text-sm text-muted-foreground font-sans">
                    <SafeHydrate><Calendar className="h-4 w-4" /></SafeHydrate>
                    <time>{displayDate}</time>
                  </div>}
                
                {post.excerpt && <p className="mt-1 text-sm text-muted-foreground font-sans line-clamp-1">
                    {post.excerpt}
                  </p>}
              </div>
            </Link>
            
            {}
            {i < posts.length - 1 && <Separator className="bg-border" />}
          </div>;
    })}
    </div>;
}
export default function LatestNews() {
  const wp_query_params = {
    per_page: 4,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="related-articles" className="bg-background py-16 sm:py-24 text-foreground">
      <div className="container mx-auto max-w-3xl px-4">
        <PostsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc"
      }}>
          <NewsListConsumer />
        </PostsProvider>
        
        <div className="mt-10 flex justify-center">
          <Button variant="secondary" className="bg-primary text-primary-foreground hover:bg-primary/90 font-sans" asChild>
            <Link to="/KnowledgePage">查看更多 VIEW ALL</Link>
          </Button>
        </div>
      </div>
    </section>;
}